<template>
  <div class="px-4 sm:px-0">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold leading-6 text-gray-900">Question checkpoint</h1>
        <p class="mt-2 text-sm text-gray-700">A list of all the Question checkpoint.</p>
      </div>
      <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        <RouterLink :to="{name: 'QuestionCheckpointCreate', params: { question_id: questionId } }" class="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Add Question Checkpoint</RouterLink>
      </div>
    </div>
    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
            <tr>
              <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
              <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Text</th>
              <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900">Options</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
            <tr v-for="item in items" :key="item.id">
              <td class="whitespace-nowrap px-3 py-1 text-sm font-medium text-gray-900 sm:pl-0">{{ item.id }}</td>
              <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                {{stripHtml(item.text).split(' ').slice(0, 10).join(" ")}} ...
              </td>
              <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                <div class="flex items-center justify-end gap-x-0">
<!--                <RouterLink type="button" :to="{ name: 'QuestionSetQuestionShow', params: { question_set_id: questionSetId, question_id: item.id } }" class="text-gray-500 hover:text-indigo-900">-->
<!--                  <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />-->
<!--                  <span class="sr-only">, {{ item.id }}</span>-->
<!--                </RouterLink>-->
                <RouterLink :to="{ name: 'QuestionCheckpointUpdate', params: { question_set_id: questionSetId, question_id:questionId, id: item.id } }" class="network-button-color hover:text-gray-900">
                  <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                </RouterLink>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
    </div>
  </div>

</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EyeIcon, PencilSquareIcon} from "@heroicons/vue/20/solid";

export default {
  name: "QuestionCheckpointIndexComponents",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null
    }
  },
  computed: {
    questionSetId() {
      return this.$route.params.question_set_id ? parseInt((this.$route.params.question_set_id)) : null;
    },
    questionId() {
      return this.$route.params.question_id ? parseInt((this.$route.params.question_id)) : null;
    },
  },
  components: {
    PaginationComponent,
    EyeIcon,
    PencilSquareIcon,
  },
  methods: {
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/question-set/${this.questionSetId}/question/${this.questionId}/checkpoint/index?page=${page}`).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    stripHtml(html)
    {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
  },
  mounted() {
    this.getItems();
  },
}
</script>